import { createSlice } from "@reduxjs/toolkit";
import { ADDED, INACTIVE } from "../../../app/constants";

const developSlice = createSlice({
  name: "develop",
  initialState: {
    exploreOpportunity: null,
    planAndCommit: null,
    assessSkill: null,
    learnOnTheGo: null,
    status: INACTIVE,
    logData: null,
    stepRatings: null,
    stepRatingQuestion: null,
    requestForPerspective: null,
  },
  reducers: {
    setExploreOpportunity: (state, action) => {
      state.exploreOpportunity = action.payload.exploreOpportunity;
      state.logData = action.payload.userLog;
      state.planAndCommit = action.payload.planAndCommit;
      state.learnOnTheGo = action.payload.learnOnTheGo;
      state.assessSkill = action.payload.assessSkill;
      state.stepRatings = action.payload.stepRatings;
      state.stepRatingQuestion = action.payload.stepRatingQuestion;
      state.requestForPerspective = action.payload.requestForPerspective;
      state.status = ADDED;
    },
  },
});

export const { setExploreOpportunity } = developSlice.actions;

export default developSlice.reducer;
